import PropTypes from 'prop-types'
import { TextArea } from '../styles'

function TextInput({ value, onChange }) {
  return (
    <TextArea
      as="textarea"
      rows={3}
      className="mt-2"
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value)}
    />
  )
}

TextInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
}

export default TextInput
